import _ from "lodash";
import { setToastMsg } from "Login/modules/LoginModule";
import { TAB_TYPES } from "./constants";

export const getTabOptions = ({ toddleDefinedEntities, t }) => {
  const options = [];

  if (!_.isEmpty(toddleDefinedEntities)) {
    options.push({
      label: t("transcript:toddle_defined"),
      value: TAB_TYPES.TODDLE,
    });
  }

  options.push({
    label: t("common:custom"),
    value: TAB_TYPES.CUSTOM,
  });

  return options;
};

export const partitionEntities = entities => {
  return _.partition(entities, ({ source }) => !source);
};

export const getManageEntitiesInitialData = ({ transcriptEntities, t }) => {
  const [customEntities, toddleDefinedEntities] = partitionEntities(
    transcriptEntities
  );

  return {
    customEntities,
    toddleDefinedEntities,
    tabOptions: getTabOptions({ toddleDefinedEntities, t }),
  };
};

export const getInitialTabValue = tabOptions =>
  _.get(tabOptions, "[0].value", TAB_TYPES.CUSTOM);

export const getOrderedRows = rows =>
  _.chain(rows)
    .map((row, index) => ({
      ...row,
      name: _.trim(row.name),
      displaySequence: index + 1,
    }))
    .filter(({ name }) => name)
    .value();

export const getRemovedEntities = ({ initialEntities, currentEntities }) => {
  const currentIds = new Set(_.map(currentEntities, "id"));

  return _.chain(initialEntities)
    .map("id")
    .filter(id => !currentIds.has(id))
    .map(id => ({ id }))
    .value();
};

export const showManageEntitiesValidationError = dispatch => {
  dispatch(
    setToastMsg({
      type: "error",
      msg: "transcript:fill_required_fields_error",
    })
  );
};
